<template>
  <section class="treneri" id="treneri">
    <div class="container">
      <div class="header-bar">
        <div class="left">
          <router-link to="/" class="back-btn">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18">
              <path d="M15 18l-6-6 6-6" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            Späť domov
          </router-link>
        </div>
        <h2>Tréneri</h2>
        <div class="right"></div>
      </div>

      <div class="trainers-grid">
        <div
          class="trainer-card wow fadeInUp"
          v-for="(trainer, index) in trainers"
          :key="index"
          :data-wow-delay="(index * 0.08) + 's'"
        >
          <div class="trainer-img">
            <img :src="trainer.image" :alt="trainer.name" />
          </div>
          <h4>{{ trainer.name }}</h4>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'

const trainers = ref([
  { name: 'Soňa',   image: require('@/assets/images/sona-rusenova.webp') },
  { name: 'Lukáš',  image: require('@/assets/images/8.webp') },
  { name: 'Klaudia',image: require('@/assets/images/2.webp') },
  { name: 'Andrej', image: require('@/assets/images/7.webp') },
  { name: 'Stefi',  image: require('@/assets/images/3.webp') },
  { name: 'Eliška', image: require('@/assets/images/6.webp') },
  { name: 'Samuel', image: require('@/assets/images/samuel-cukan.webp') },
  { name: 'Zuzana', image: require('@/assets/images/zuz-pataky.webp') },
  { name: 'Matúš',  image: require('@/assets/images/matusturzo.webp') },
])
</script>

<style scoped>
.treneri {
  background: #111;
  color: #fff;
  min-height: 100vh;
  padding: 100px 0 80px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  width: 90%;
}

/* Header bar */
.header-bar {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  margin-bottom: 56px;
}

.left {
  justify-self: start;
}

.right {
  justify-self: end;
}

.header-bar h2 {
  font-size: clamp(26px, 4vw, 36px);
  color: #E8B923;
  text-align: center;
  position: relative;
}

.header-bar h2::after {
  content: '';
  display: block;
  width: 48px;
  height: 3px;
  background: #E8B923;
  border-radius: 2px;
  margin: 10px auto 0;
}

.back-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  color: #E8B923;
  border: 2px solid #E8B923;
  border-radius: 30px;
  padding: 8px 18px;
  transition: background-color 0.25s ease, color 0.25s ease, transform 0.2s ease;
}

.back-btn:hover {
  background-color: #E8B923;
  color: #000;
  transform: translateX(-2px);
}

/* Grid */
.trainers-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.trainer-card {
  background: #1a1a1a;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid transparent;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.4);
  cursor: default;
}

.trainer-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 12px 32px rgba(232, 185, 35, 0.2);
  border-color: rgba(232, 185, 35, 0.3);
}

.trainer-img {
  aspect-ratio: 2 / 3;
  overflow: hidden;
}

.trainer-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top center;
  display: block;
  transition: transform 0.4s ease;
}

.trainer-card:hover .trainer-img img {
  transform: scale(1.04);
}

.trainer-card h4 {
  font-size: 15px;
  color: #E8B923;
  text-align: center;
  padding: 14px 10px;
  letter-spacing: 0.03em;
}

/* Responsive */
@media (max-width: 1100px) {
  .trainers-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .trainers-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
  }

  .header-bar {
    grid-template-columns: 1fr;
    gap: 14px;
    margin-bottom: 32px;
  }

  .header-bar h2 {
    text-align: left;
  }

  .header-bar h2::after {
    margin-left: 0;
  }
}

@media (max-width: 420px) {
  .trainers-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: 12px;
  }
}
</style>
